import { createFrame, innerFrame, step1, step2, step3, step4, animateOpen, countryOpen, agreement, inputerror, overlay, termserror, flyIn, fadeIn, accountHelpWindow, ResetPassword, ForgotUsername, FacebookLogin, VerificationEmail, RecoverPasswordTab, ForgottenUsernameTab, VerifyEmailTab, recoveryerror, customgender  } from './login.animations';
import { Component, OnInit, ViewChild, EventEmitter, Output, ElementRef, Renderer } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { ReCaptchaComponent } from 'angular2-recaptcha';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { UserService } from '../../services/user.service';
import { Account } from '../../models/account';
import { Country } from '../../models/country';

@Component({
  selector: 'login-options',
  templateUrl: './login.panel.html',
  providers: [ UserService ],
  outputs: ['login'],
  animations: [createFrame, innerFrame, step1, step2, step3, step4, animateOpen, countryOpen, agreement, inputerror, overlay, termserror, flyIn, fadeIn, accountHelpWindow, ResetPassword, ForgotUsername, FacebookLogin, VerificationEmail, RecoverPasswordTab, ForgottenUsernameTab, VerifyEmailTab, recoveryerror, customgender ]
})
export class LoginPanelComponent implements OnInit {
	
	@ViewChild('Year') year: ElementRef;
	@ViewChild('Month') month: ElementRef;
	@ViewChild('Day') day: ElementRef;
	@ViewChild('newsletter') newsletter: ElementRef;
	@ViewChild('PasswordField') PasswordField: ElementRef;
	@ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;
	
	years = [];
	months = [];
	days = [];

	constructor(private userService: UserService,
  			  	private router: Router,
  			  	private rd: Renderer) {

		this.years  = this.generateYears();
		this.months = this.generateMonths();
		this.days  = this.generateDays();

	}

	openYear = false;
	openMonth = false;
	openDay = false;
	openCountries = false;

	button: string;
	today: any;
	accounts: Account;
	countries: Country;

	/**
	* 		Login box form model
	**/
	model = new Login('', '', '');
	recovery = new Recovery('', '');
	newuser = new User();
	
	// Page States
	loginstate = 'false';
	showRecovery: any;
	recoveryState = 'in';
	recoveryError = "";
	recoveryCode = 0;
	authServices = ['steam', 'facebook', 'live'];

	// Service state (?)
	oauthSteam: any;
	oauthFacebook: any;
	oauthLive: any;
	paypalCheckout: any;
	sft: boolean;

	// Error handling
	loading = [];
	loggedIn = false;
	erruser: boolean;
	errpwd: boolean;
	erremail: boolean;
	customgender: any;

	error: string;
	err = 'false';
	errorCode = 0;
	errorMsg = '';
	signupError = '';
	signupCode = 0;
	oAuthtimer: any;
	

	// New user step / animation state
	state = '1';

	// Generate Array of Months
	generateCountries() {
		Promise.resolve( this.userService.getCountryCodes() ).then( (data) => {
			this.countries = data;
		});
	}


	// Select a birthday
	focus(el) {
		if ( this[el] ) {
			let kap = el.toUpperCase();
			this['open'+kap] = false;
			this.rd.invokeElementMethod(this[el].nativeElement,'focus');
		}
	}


	logIn() {

		this.userService.login(this.model.username, this.model.password)
			.subscribe( (result) => {
				
				if (result.code === 200) {

					this.error = '';
					this.loginstate = 'true';
					this.button = 'Welcome';
					this.userService.authorizeUser();
					window.location.reload();

				} else {
					this.error = result.message;
				}
			});
		this.today = Date.now();
	}



	recoverPassword() {
		console.log('recoverPassword');
		if ( this.recovery.email != '' || this.recovery.username != '' ) {
			this.userService.recoverPassword(this.recovery.username, this.recovery.email)
				.subscribe(result => {
					if (result.code == 200) {
						this.recoveryCode = 200;
						this.recoveryError = "Recovery Key Sent";
					} else {
						this.recoveryCode = 400;
						this.recoveryError = result.err;
					}
			});
			setTimeout (() => { 
				this.recoveryCode = 0;
				this.recoveryError = "";
			}, 8000);
		}
	}


	recoverUsername() {
		console.log('recoverUsername');
		if ( this.recovery.email != '') {
			this.userService.recoverUsername(this.recovery.email)
				.subscribe(result => {
					if (result.code == 200) {
						this.recoveryCode = 200;
						this.recoveryError = "Username Sent to "+this.recovery.email;
					} else {
						this.recoveryCode = 400;
						this.recoveryError = result.err;
					}
			});
			setTimeout (() => { 
				this.recoveryCode = 0;
				this.recoveryError = "";
			}, 8000);
		}
	}


	verfiyEmail() {
		console.log('verfiyEmail');
		if ( this.recovery.email != '') {
			this.userService.verifyEmail(this.recovery.email)
				.subscribe(result => {
					if (result.code == 200) {
						this.recoveryCode = 200;
						this.recoveryError = "Verification code sent to "+this.recovery.email;
					} else {
						this.recoveryCode = 400;
						this.recoveryError = result.err;
					}
			});
			setTimeout (() => { 
				this.recoveryCode = 0;
				this.recoveryError = "";
			}, 8000);
		}
	}




	/**
	* Authorize a logged in user to make a purchase
	**/
	authorize() {
		// Send the authorization request
		this.userService.authorizeUser().subscribe((user) =>  {
			this.accounts = user;
			if ( user )
				this.loggedIn = true;
		});
	}


	oauthLogin(service) {
		this.loading[service] = true;
		this.oAuthtimer = setInterval( () => {
			this.userService.checkOAuth(service)
			.subscribe(result => {
				if (result === true) {
					this.error = '';
					clearInterval(this.oAuthtimer);			
					this.loginstate = 'true';
					this.button = 'Welcome';
					
					this.authorize();
					// this.router.navigate(['/account/view']);
					// window.location.pathname = '/account/view';
					location.reload();
				}
			});
		}, 2000);
	}

	waitForOAuthResponse(service, data) {
		
	}

	openWindow(windowHeight, windowWidth, windowName, windowUri) {

		var centerWidth = (window.screen.width / 2) - windowWidth;
		var centerHeight = (window.screen.height / 2) - windowHeight;

		let newWindow = window.open(windowUri, windowName, 'location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=0,width=' + windowWidth + 
			',height=' + windowHeight + 
			',left=' + centerWidth + 
			',top=' + centerHeight);
		return newWindow.name;
	}



	/**
	* Sign up a new user
	**/

	// Does the username exist?
	checkAccount(e?) {
		this.userService.checkUser(this.newuser.username)
			.subscribe(result => {
				this.erruser = result ? true : false;
			});
	}

	// Is the email address already known?
	checkAddress(e?) {
		this.userService.checkEmail(this.newuser.email)
			.subscribe(result => {
				this.erremail = result ? true : false;
			});
	}

	// Is the password considered secure enough?
	checkPassword(e?) {
		if ( this.newuser.password )
			this.errpwd = (this.newuser.password.length < 6) ? true : false;
	}


	// Create a new Identity...
	createIdentity() {

		// Capture RECAPTCHA request token
		this.newuser.token = this.captcha.getResponse();
		

		// Send a request to create the user
		Promise.resolve(this.userService.createAccount(this.newuser)).then((data) => {

			// Was there an error creating the user?
			if ( data.code == 400 ) {
				this.signupError = data.error; // Set the error message
				this.signupCode = data.code;   // and status code
			} else if (data.code == 200) {
				// The account was created sucessfully
				this.accounts = data.user;
				this.loggedIn = true;
				this.authorize();
				location.reload();
			}

			
		});

		// Reset the error result after a time on screen
		setTimeout (() => { this.signupError = ''; }, 10000);
	}


	oAuthURLs() {

		Promise.resolve( this.userService.generateOAuthURL('steam') ).then((data) => { 
			this.oauthSteam = data;
		});

		Promise.resolve( this.userService.generateOAuthURL('facebook') ).then((data) => { 
			this.oauthFacebook = data;
		});

		Promise.resolve( this.userService.generateOAuthURL('live') ).then((data) => { 
			this.oauthLive = data;
		});
	}

	
	loginKey(e) {
		if ( e.keyCode == 13 )
			this.logIn()

		if ( e.keyCode == 17 )
			this.sft = true

		if ( e.keyCode == 9 ) {
			this.focus('PasswordField');
			return false;
		}
	}


	createKey(e) {
		if ( e.keyCode == 13 ) {
			this.createIdentity();
		} else if ( e.keyCode == 9 ) {
			return false;
		}
	}

	// Generate Array of Years
	generateYears(endYear = 1900) {
		var currentYear = new Date().getFullYear(), years = [];
		while ( endYear <= currentYear ) { years.push(currentYear--); }
		return years;
	}

	// Generate Array of Months
	generateMonths() {
		return [ "January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December" ];
	}

	// Generate Array of Years
	generateDays() {
		let day = 1, days = [];
		while ( days.length <= 32 ) { days.push(day++); }
		return days;
	}

	unfocus() {
		this.openYear = false;
		this.openMonth = false;
		this.openDay = false;
	}

	/* On with the show */
	ngOnInit() {
		this.authorize();
		this.oAuthURLs();
		this.generateCountries();
	}

	ngOnDestroy() {
	    clearInterval(this.oAuthtimer);
	}

}


// This constructor generates the Login form
export class Login {

  constructor(
	public username: string,
	public password: string,
	public token: any
  ) {}

}

// Export the constructor Login form
export class User {

	constructor(
		public username?: string,
		public password?: string,
		public confirmpassword?: string,
		public firstname?: string,
		public surname?: string,
		public email?: string,
		public confirmemail?: string,
		public token?: any,
		public birthday?: any,
		public country?: any,
		public year?: number,
		public month?: number,
		public day?: number,
		public sex?: string,
		public newsletter?: boolean,
		public terms?: boolean
	) {}

}


export class Recovery {
	constructor(
		public username: string,
		public email: string
	) {}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/login/login.panel.component.ts